export default __webpack_public_path__ + "static/media/rock3.44349fa1.jpg";